module.exports = __webpack_public_path__ + "img/zs-opatov.d42fa4ca.jpg";